import React from 'react';
import { PropTypes } from 'prop-types';

const HintButtonComponent = ({
  id,
  hintType,
  active,
  onClick,
  buttonBackground
}) => (
  <button
    id={ id }
    type="button"
    onClick={ () => onClick() }
    className="hint-button"
    style={ { backgroundColor: active ? '#1f3460' : buttonBackground } }
  >
    <svg className="svg-icon" style={ { fill: active ? '#fff' : '#1f3460' } }>
      <use xlinkHref={ `assets/images/hint-defs.svg#${ hintType }-icon` } />
    </svg>
  </button>
);

HintButtonComponent.propTypes = {
  id: PropTypes.string,
  hintType: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonBackground: PropTypes.string
};

HintButtonComponent.defaultProps = {
  buttonBackground: 'rgba(255, 255, 255, .75)',
  id: null
};

export default HintButtonComponent;
